import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchAllRequests = async () => {
  const response = await fetch(`${REACT_APP_VMS_BASE_URL}/requests`);
  const result = await response.json();
  return result;
};

export default fetchAllRequests;
